import { PROCESS_TYPE_CONFIG } from "../components/Constants/downloadAppModal"
import { ProcessData } from "../components/Types/downloadAppModal"
import { v4 as uuidv4 } from 'uuid';
import { createPreference, createPreferenceWithExtras, createRipple, enableTANCSync, tancAssociationStatusSync } from "src/utilities/AppSyncPlusAPIs";
import { AppData, UploadModel } from "../components/Types/uploadAppModal";
import { TEMPLATE_APP } from "../Constants";
import { getMissingFields } from "src/Ateam-BI/utils/generalUtils";
import { SECONDARY_DETAILS } from "../components/Constants/uploadAppModal";

const createTancFilters = async (processData: ProcessData, tancId: string, userId: string) => {
    const filterCreationPromises = processData.tanc?.filters?.map((filter):Promise<any> => {
        return new Promise((resolve, reject) => {
        createPreferenceWithExtras(uuidv4(), 'FILTER', filter.label, tancId, 'TANC', userId, filter.information, filter.extras, null
            , function onSuccess(response:any) { resolve(response) }
            , function onFailure(error:any) { reject(error) }
        )
        })
    })
    filterCreationPromises && await Promise.all(filterCreationPromises);
}

const createTancPermissions = async (processData: ProcessData, tancId: string, userId: string) => {
    const permissionCreationPromises = processData.tanc?.permissions?.map((permission):Promise<any> => {
        return new Promise((resolve, reject) => {
        createPreference(uuidv4(), 'PERMISSIONS', permission.label, tancId, 'TANC', userId, permission.information, null
            , function onSuccess(response:any) { resolve(response) }
            , function onFailure(error:any) { reject(error) }
        )
        })
    })
    permissionCreationPromises && await Promise.all(permissionCreationPromises);
}

    const createTancConfiguration = async (processData: ProcessData, tancId: string, userId: string) => {
    const configuration = processData.tanc?.configuration ? processData.tanc?.configuration[0] : undefined;
    if (!configuration) return;
    await new Promise((resolve, reject) => {
        createPreference(uuidv4(), 'CONFIGURATION', configuration.label, tancId, 'TANC', userId, configuration.information, null
        , function onSuccess(response:any) {resolve(response)}
        , function onFailure(error:any) {reject(error)}
        )
    })
}

const getTANCSchema = (processData: ProcessData, currentStage: string) => {
    let schema = 'frisco'
    if (currentStage != 'beta' && currentStage != 'dev') {
    if (processData?.critical_data && processData?.sox_approved) {
        schema = "frisco_sox"
    } else if (processData?.critical_data) {
        schema = "frisco_critical"
    } else {
        schema = "frisco_ext"
    }
    }
    return schema
}

const getTANCUpstreamSOURCE = async (processData:ProcessData, processType: string, currentStage: string) => {
    if (processType === "flexico") return null;
    if (processType === "frisco") {
    if (processData.redshift_table_name) {
        `${getTANCSchema(processData, currentStage)}.${processData.redshift_table_name}`
    }
    }
}

const getTANCUpstreamType = async (processType: string) => {
    switch(processType) {
    case "frisco":
        return "FAST"
    case "flexico":
        return "S3"
    default:
        return null;
    }
}

const createTanc = async (processData:ProcessData, processType: string, userId: string, currentStage: string) => {
    const { processKey, tancKey } = PROCESS_TYPE_CONFIG[processType];
    const processId = processData[processKey];
    const tanc = await enableTANCSync(processId, tancKey, getTANCUpstreamSOURCE(processData, processType, currentStage), getTANCUpstreamType(processType), `TEMP_${tancKey}_${processId}`)
    const tancId = await tancAssociationStatusSync(processId, tancKey);
    await createTancFilters(processData, tancId, userId);
    await createTancPermissions(processData, tancId, userId);
    await createTancConfiguration(processData, tancId, userId);
    return tanc;
}

const createRippleSync = async (processData:ProcessData) => {
    if (processData.ripples && processData.ripples.length > 0) {
    const rippleCreationPromises = processData.ripples.map((ripple) => {
        const rippleData = structuredClone(ripple);
        rippleData.mapping_id = processData.mapping_id;
        rippleData.app_id = processData.app_id;
        return new Promise((resolve, reject) => {
        createRipple(rippleData, function onSuccess(response:any) {
            resolve(response);
        }, function onFailure(error:any) {
            reject(error);
        });
        })
    })
    await Promise.all(rippleCreationPromises);
    }
    return;
}

export const addSecondaryDetails = async (processData:ProcessData, processType: string, userId: string, currentStage: string) => {
    const secondaryDetailsCreationPromise = [];
    const {tanc, ripples} = processData;
    if (tanc && Object.keys(tanc).length) {
    secondaryDetailsCreationPromise.push(createTanc(processData, processType, userId, currentStage))
    }
    if (ripples && ripples.length > 0) {
    secondaryDetailsCreationPromise.push(createRippleSync(processData))
    }
    await Promise.all(secondaryDetailsCreationPromise);
}

export const removeSecondaryDetails = (processData:ProcessData) => {
    const localProcessData = structuredClone(processData);
    SECONDARY_DETAILS.forEach(secondaryDetail => {
    delete localProcessData[secondaryDetail];
    })
    return localProcessData;
}

export const getSecondaryDetailData = (processData: ProcessData, processType: string, processId: string, mappingId?: string) => {
    const { processKey } = PROCESS_TYPE_CONFIG[processType];
    const secondaryDetailData = structuredClone(processData);
    secondaryDetailData[processKey] = processId;
    secondaryDetailData.mapping_id = mappingId;
    return secondaryDetailData;
}

export const hasDuplicateAppName = (appNames: Set<string>, uploadModel: UploadModel) => {
  if (uploadModel.app?.appData?.app_name) {
    return appNames.has(uploadModel.app?.appData?.app_name.trim());
  }
  return false
}

export const findMissingFields = (appData: AppData) => {
    const requiredFields = [
        TEMPLATE_APP.APP_DESCRIPTION, TEMPLATE_APP.APP_NAME, TEMPLATE_APP.STATUS,
        TEMPLATE_APP.ORGANIZATION, TEMPLATE_APP.AUTOMATION_TOOLS, TEMPLATE_APP.PROCESS_OWNER, 
        TEMPLATE_APP.VP, TEMPLATE_APP.GRC_CONTROL_OWNER, TEMPLATE_APP.CADENCE, 
        TEMPLATE_APP.FINANCIAL_RELEVANCE, TEMPLATE_APP.LEDGER_INFO, TEMPLATE_APP.FINANCIAL_YEAR_IMPACT, 
        TEMPLATE_APP.PERMISSION, TEMPLATE_APP.OUTPUT, TEMPLATE_APP.PDD, 
        TEMPLATE_APP.ANNUAL_MER_SAVINGS, TEMPLATE_APP.LAUNCH_MCM, TEMPLATE_APP.LAUNCH_QQ_YY
    ]

    const missingFields = getMissingFields(appData, requiredFields);
    return missingFields;
}

export const getAppDetailsUrl = (appId: string) => {
    return `/App/${appId}?view=details`;
}